exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fas[data-v-7df28282]{font-size:2em;opacity:.75;margin-top:.2em}.option-control[data-v-7df28282]{width:auto}.option-selected[data-v-7df28282]{background:#795bf3}.option-selected .option-body[data-v-7df28282],.option-selected .option-title[data-v-7df28282]{color:#fff!important}.option-selected .fas[data-v-7df28282]{color:#fff}.option-body[data-v-7df28282]{margin-top:-2.1em}", ""]);

// exports
